import { CHECK_IN_PROMPTS } from './prompts';
import { checkInResponseCreateSchema } from './schema';
import type {
  CheckInResponseCreate,
  CheckInResponseCreateInput,
} from './types';

export function prepareCheckInResponseCreates(
  planId: string,
  responses: CheckInResponseCreateInput,
): CheckInResponseCreate[] {
  return CHECK_IN_PROMPTS.reduce<CheckInResponseCreate[]>((acc, prompt) => {
    const response = responses[prompt.key];
    if (!response || response.trim() === '') {
      return acc;
    }

    const parsed = checkInResponseCreateSchema.parse({
      planId,
      promptKey: prompt.key,
      promptText: prompt.text,
      response: response.trim(),
    });

    acc.push(parsed);
    return acc;
  }, []);
}
